export namespace IntegrationsAction {

  export class LoadIntegrations {
    static readonly type = '[Integrations] Load Integrations';
    constructor() { }
  }

  export class postFormDataIntegration {
    static readonly type = '[Integrations] Post Form Data Integration';
    constructor(public integrationId: number, public formData: any) { }
  }

}
